module.exports = __webpack_public_path__ + "static/media/light.d81d3018.svg";